var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { staticClass: "mt" },
    [
      _c("w-col", { attrs: { xs: "12" } }, [
        _c("div", { staticClass: "promo" }, [
          _c(
            "div",
            { staticClass: "promo-icon" },
            [_c("w-fa", { attrs: { icon: ["fas", "gift"], size: "lg" } })],
            1
          ),
          _c("div", { staticClass: "promo-body" }, [
            _c("h3", { staticClass: "promo-title" }, [
              _vm._v(_vm._s(_vm.$ct("promo-title"))),
            ]),
            _c("p", { staticClass: "promo-intro" }, [
              _vm._v(" " + _vm._s(_vm.$ct("promo-intro")) + " "),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://www.winfakt.be/beveel-winfakt-aan",
                    target: "_blank",
                    rel: "noopener",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("promo-conditions")) + " ")]
              ),
            ]),
          ]),
        ]),
      ]),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c(
            "w-card",
            { staticClass: "grow" },
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("share-title")))]),
              _c("w-card-content", [
                _c("p", { staticClass: "intro" }, [
                  _vm._v(" " + _vm._s(_vm.$ct("share-intro")) + " "),
                ]),
                _c(
                  "div",
                  { staticClass: "linkrow" },
                  [
                    _c("w-input", {
                      staticClass: "linkfield",
                      attrs: {
                        value: _vm.referralLink,
                        label: _vm.$ct("labels.your-link"),
                        fancy: "",
                        readonly: "",
                      },
                      on: {
                        focus: function ($event) {
                          return _vm.selectAll($event)
                        },
                      },
                    }),
                    _c("w-button", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("copy-link"),
                          expression: "$ct('copy-link')",
                        },
                      ],
                      staticClass: "copy-btn",
                      attrs: { icon: "copy" },
                      on: {
                        click: function ($event) {
                          return _vm.copyLink()
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "share" }, [
                  _c("span", { staticClass: "share-label" }, [
                    _vm._v(_vm._s(_vm.$ct("share-label"))),
                  ]),
                  _c(
                    "button",
                    {
                      staticClass: "share-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.share("whatsapp")
                        },
                      },
                    },
                    [
                      _c("w-fa", { attrs: { icon: ["fab", "whatsapp"] } }),
                      _vm._v(" " + _vm._s(_vm.$ct("share.whatsapp")) + " "),
                    ],
                    1
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "share-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.share("linkedin")
                        },
                      },
                    },
                    [
                      _c("w-fa", { attrs: { icon: ["fab", "linkedin"] } }),
                      _vm._v(" " + _vm._s(_vm.$ct("share.linkedin")) + " "),
                    ],
                    1
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "share-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.share("email")
                        },
                      },
                    },
                    [
                      _c("w-fa", { attrs: { icon: ["fas", "envelope"] } }),
                      _vm._v(" " + _vm._s(_vm.$ct("share.email")) + " "),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c(
            "w-card",
            { staticClass: "grow" },
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("invite-title")))]),
              _c(
                "w-card-content",
                [
                  _c("p", { staticClass: "intro" }, [
                    _vm._v(" " + _vm._s(_vm.$ct("invite-intro")) + " "),
                  ]),
                  _c("w-input", {
                    attrs: {
                      label: _vm.$ct("labels.email"),
                      fancy: "",
                      type: "email",
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.sendInvite()
                      },
                    },
                    model: {
                      value: _vm.inviteEmail,
                      callback: function ($$v) {
                        _vm.inviteEmail = $$v
                      },
                      expression: "inviteEmail",
                    },
                  }),
                  _c(
                    "app-error-message",
                    { attrs: { hide: _vm.inviteError == "" } },
                    [
                      _vm.inviteError
                        ? _c("span", [_vm._v(_vm._s(_vm.inviteError))])
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "w-card-actions",
                [
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      attrs: { disabled: !_vm.canInvite, loading: _vm.sending },
                      on: {
                        click: function ($event) {
                          return _vm.sendInvite()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$ct("send-invite")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-card",
            { staticClass: "grow" },
            [
              _c("w-card-title", [
                _vm._v(_vm._s(_vm.$ct("my-referrals-title"))),
              ]),
              _c("w-card-content", [
                _vm.referrals.length == 0 && _vm.invites.length == 0
                  ? _c("p", { staticClass: "empty" }, [
                      _vm._v(" " + _vm._s(_vm.$ct("no-referrals")) + " "),
                    ])
                  : _c("table", { staticClass: "referral-table" }, [
                      _c("thead", [
                        _c("tr", [
                          _c("th", [_vm._v(_vm._s(_vm.$ct("table.name")))]),
                          _c("th", [_vm._v(_vm._s(_vm.$ct("table.date")))]),
                          _c("th", [_vm._v(_vm._s(_vm.$ct("table.status")))]),
                          _c("th", { staticClass: "amount" }, [
                            _vm._v(_vm._s(_vm.$ct("table.yearly-reward"))),
                          ]),
                        ]),
                      ]),
                      _c(
                        "tbody",
                        [
                          _vm._l(_vm.referrals, function (r) {
                            return _c("tr", { key: "r" + r.id }, [
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    r.referredCompanyName ||
                                      _vm.$ct("table.new-account")
                                  )
                                ),
                              ]),
                              _c("td", [
                                _vm._v(_vm._s(_vm.formatDate(r.dateCreated))),
                              ]),
                              _c("td", [
                                _c(
                                  "span",
                                  { staticClass: "badge badge-success" },
                                  [_vm._v(_vm._s(_vm.$ct("status.registered")))]
                                ),
                                r.rewarded
                                  ? _c(
                                      "span",
                                      { staticClass: "badge badge-reward" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$ct("status.rewarded"))
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                              _c("td", { staticClass: "amount" }, [
                                _vm._v(
                                  _vm._s(
                                    r.yearlyReward > 0
                                      ? _vm.formatReward(r.yearlyReward)
                                      : "—"
                                  )
                                ),
                              ]),
                            ])
                          }),
                          _vm._l(_vm.pendingInvites, function (i) {
                            return _c("tr", { key: "i" + i.id }, [
                              _c("td", [_vm._v(_vm._s(i.email))]),
                              _c("td", [
                                _vm._v(_vm._s(_vm.formatDate(i.dateSent))),
                              ]),
                              _c("td", [
                                _c(
                                  "span",
                                  { staticClass: "badge badge-pending" },
                                  [_vm._v(_vm._s(_vm.$ct("status.invited")))]
                                ),
                              ]),
                              _c("td", { staticClass: "amount" }, [
                                _vm._v("—"),
                              ]),
                            ])
                          }),
                        ],
                        2
                      ),
                      _vm.totalYearlyReward > 0
                        ? _c("tfoot", [
                            _c("tr", [
                              _c(
                                "td",
                                {
                                  staticClass: "total-label",
                                  attrs: { colspan: "3" },
                                },
                                [_vm._v(_vm._s(_vm.$ct("table.total-yearly")))]
                              ),
                              _c("td", { staticClass: "amount total-amount" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatReward(_vm.totalYearlyReward)
                                  )
                                ),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }